<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pLaCrn/tc-custom/9780226826318.jpg?1722574797109" alt="This image is the cover for the book Democracy for Busy People"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Democracy for Busy People
      </h1>
      <p class="bookDescription body article font2">
        <b>Advances an alternative approach to democratic reform that focuses on building institutions that empower people who have little time for politics.</b><br/>  <br/> How do we make democracy more equal? Although in theory, all citizens in a democracy have the right to participate in politics, time-consuming forms of participation often advantage some groups over others. Where some citizens may have time to wait in long lines to vote, to volunteer for a campaign, to attend community board meetings, or to stay up to date on national, state, and local news, other citizens struggle to do the same. Since not all people have the time or inclination to devote substantial energy to politics, certain forms of participation exacerbate existing inequalities.<br/>  <br/><i>Democracy for Busy People</i> takes up the very real challenge of how to build a democracy that empowers people with limited time for politics. While many plans for democratic renewal emphasize demanding forms of political participation and daunting ideals of democratic citizenship, political theorist Kevin J. Elliott proposes a fundamentally different approach. He focuses instead on making democratic citizenship undemanding so that even busy people can be politically included. This approach emphasizes the core institutions of electoral democracy, such as political parties, against deliberative reforms and sortition. Timely and action-focused, <i>Democracy for Busy People</i> is necessary reading.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J. Elliott
      </h2>
      
      <p class="authorDescription body article"><B>Kevin J. Elliott</B> is a political theorist and assistant professor of political science at Murray State University.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a4be4d9